<template lang="html">
  <div>
    <div class="panel panel-info">
      <div class="panel-heading">
        <h3 class="panel-title">Jugadores</h3>
      </div>
      <div class="panel-body">
        <div>
          <div class="form-inline">
            <div class="col-sm-6">
              <input v-model="filterKey" placeholder="Search..." class="form-control">
            </div>
            <div class="col-sm-6">
              <button class="btn btn-default" @click="clearSearch">Limpiar</button>
            </div>
          </div>
        </div>
        <div>
          <table class="table table-bordered table-condensed table-hover">
            <thead>
              <tr>
                <th>País</th>
                <th>Nombre</th>
                <th>Cancha</th>
                <th>Agregar</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="registration in registrations | filterBy filterKey | orderBy 'player.surname'">
                <td>
                  <span class="flag-icon flag-icon-{{registration.player.country.code | lowercase}}"></span>
                </td>
                <td>
                  {{registration.player.surname}} {{registration.player.mothers_surname}} {{ registration.player.name}} {{registration.player.middle_name}}
                </td>
                <td>
                  {{registration.course.name}}
                </td>
                <td>
                  <button type="button" class="btn btn-default" @click="addToTeam(registration)">+</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import Player from '../../api/player'
import Team from '../../api/team'
import {
  getConfigRegistrations,
  getConfigTeam
} from '../../vuex/getters'
import * as actions from '../../vuex/actions'
export default {
  vuex: {
    getters: {
      registrations: getConfigRegistrations,
      team: getConfigTeam
    },
    actions
  },
  data() {
    return {
      filterKey: ''
    };
  },
  computed: {},
  ready() {},
  attached() {},
  methods: {
    clearSearch() {
      this.filterKey = ''
    },
    addToTeam(registration) {
      let ApiPlayer = new Player()
      ApiPlayer.attach(registration.id, this.team.id).then(response => {
        this.getTeam(this.team.id)
      })
    },
    getTeam(id) {
      let ApiTeam = new Team()
      ApiTeam.get(id).then(response => {
        this.setConfigTeam(response.data)
      }, error => {
        this.setError({show: true, message:'Failed getting team'})
      })
    }
  },
  components: {}
}
</script>

<style lang="css">
</style>



/** WEBPACK FOOTER **
 ** TeamPlayers.vue?39611462
 **/